// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import store from './store'
import Fun from './assets/js/index.js'; // 公共方法

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: '4GkMgTPCYGPAdg9xGfrjwpmAguVyv9nH' //  在此输入你自己的百度地图ak
})

import {
  getUserData,
  postUserData,
  getMallData,
  getMallData1,
  postMallData,
  postMallData1,
  deleteMallData,
  getWeatherData
} from '@/assets/api/index.js'; // 引入全局 axios 请求
Vue.config.productionTip = false

// 引入全局 axios 请求
window.getUserData = getUserData;
window.postUserData = postUserData;
window.getMallData = getMallData;
window.getMallData1 = getMallData1;
window.postMallData = postMallData;
window.postMallData1 = postMallData1;
window.deleteMallData = deleteMallData;
window.getWeatherData = getWeatherData;


Vue.use(ElementUI);
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import {
  Message
} from 'element-ui'

Vue.use(VueAwesomeSwiper, /* { default global options } */ )

// 引入面包屑自定义组件。index.js是组件的默认入口
import BreadCrumb from './components/index.js'
Vue.use(BreadCrumb);

// 瀑布流
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

//
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

router.beforeEach((to, from, next) => {
  // let islogin = localStorage.getItem("token");
  // if(to.path == "/travelNotes/edit" || to.path == "/checkOrder"){
  //   if(islogin){
  //     next();
  //   }else{
  //     Message({
  //       showClose: true,
  //       message:'请先登录',
  //       type: "warning",
  //       center: true,
  //       duration:1000
  //     })
  //     setTimeout(function(){
  //       next("/login");
  //     },1000)
  //   }
  // }else{
  //   next();
  // }
  next();
})


//公共方法
Vue.mixin(Fun);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js